module.exports = __webpack_public_path__ + "assets/8a70eec5a46e423328f1e9d7d1a87f41.js";